/* @flow */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Icon } from 'semantic-ui-react';
import PageSelector from 'catalog/screens/shared/components/PageSelector';
import type { HomeContentHeader } from '../index';

type Props = {
  header: HomeContentHeader,
  onPageSelected: (page: CatalogPage) => void,
  onPageDeleted: () => void,
};

type State = {
  selectorVisible: boolean,
};

class HeaderPageSelector extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorVisible: false,
    };
  }

  showSelector = () => this.setState({ selectorVisible: true });
  hideSelector = () => this.setState({ selectorVisible: false });

  onPageSelected = (page: CatalogPage) => {
    this.hideSelector();
    this.props.onPageSelected(page);
  };

  render() {
    const { header, onPageDeleted } = this.props;
    const { selectorVisible } = this.state;

    const content = () => {
      if (header.page) {
        return (
          <Form.Input
            iconPosition="left"
            label="Liaison vers la page"
            value={header.page.name}
            readOnly
            action
          >
            <Icon name="chevron right" />
            <input />
            <Link
              to={`/pages/${header.page.id}`}
              target="innoctopus"
              className="ui button"
            >
              Editer
            </Link>
            <button
              type="button"
              className="ui red icon button"
              onClick={onPageDeleted}
            >
              <i className="close icon" />
            </button>
          </Form.Input>
        );
      } else {
        return (
          <div>
            <Button
              onClick={this.showSelector}
              type="button"
              fluid
              labelPosition="right"
              icon="plus"
              content="Sélectionner une page"
              floated="right"
            />
          </div>
        );
      }
    };

    return (
      <div>
        {content()}
        <PageSelector
          visible={selectorVisible}
          onSelected={this.onPageSelected}
          onCancel={this.hideSelector}
        />
      </div>
    );
  }
}

export default HeaderPageSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/home/components/HeaderPageSelector.js